<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.Brand"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-producer">
  {{ colVm?.columnTitle }}
</div>
